import { DINEIN_TYPE, PICKUP_TYPE, TAKEAWAY } from '../webStorage/keys/sessionKeys';
import { getOrderTypeSession } from '../webStorage/manageOrderType';
import { isUserLoggedIn } from './isUserLoggedIn';

const isLoyaltyShowing = (orderType, restaurantSetting) => {
  if (!isUserLoggedIn()) return false;

  const isDineInOrTakeAway =
    orderType == DINEIN_TYPE ||
    (orderType == PICKUP_TYPE && getOrderTypeSession()?.pickupType == TAKEAWAY);

  if (!restaurantSetting?.loyalty_settings_v2?.is_loyalty_active) return false;

  /* Shouldn't show loyalty for logged out User when no login is enabled */
  return !(
    restaurantSetting?.settings?.global?.no_login_workflow &&
    !isUserLoggedIn() &&
    isDineInOrTakeAway
  );
};
export default isLoyaltyShowing;
